export const finishThickness = [
  { value: '0.125', text: '0.125"' },
  { value: '0.093', text: '0.093"' },
  { value: '0.078', text: '0.078"' },
  { value: '0.062', text: '0.062"' },
  { value: '0.040', text: '0.040"' },
  { value: '0.031', text: '0.031"' },
  { value: '0.024', text: '0.024"' },
  { value: '0.014', text: '0.014"' },
];

export const solderMaskColorOptions = [
  { value: 'Green', text: 'Green' },
  { value: 'Matte Green', text: 'Matte Green' },
  { value: 'Black', text: 'Glossy Black' },
  { value: 'Matte Black', text: 'Matte Black' },
  { value: 'Blue', text: 'Blue' },
  { value: 'Matte Blue', text: 'Matte Blue' },
  { value: 'Red', text: 'Red' },
  { value: 'White', text: 'White' },
];